import { GET_COMPETENCIES__FAIL, GET_COMPETENCIES__SUCCESS, GET_COMPETENCIES_START } from './constants';

const initialState = {
  competencies: null,
  isLoading: false,
};

// eslint-disable-next-line
export default (state = initialState, { type, response, headers }) => {
  switch (type) {
    case GET_COMPETENCIES_START:
      return {
        ...state,
        isLoading: true,
      };

    case GET_COMPETENCIES__SUCCESS:
      return {
        ...state,
        competencies: response,
        isLoading: false,
      };

    case GET_COMPETENCIES__FAIL:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
